import * as React from 'react';
import { useSelector } from 'react-redux';

import { useUnavailableProgramModal } from './hooks';
import { trackDealButtonClick } from './tracking';
import { ConnectToProgramButton } from '../../components/ConnectToProgramButton';
import { UnavailableProgramModal } from '../../components/UnavailableProgramModal';
import { selectIsPartnerRewardsRegistrationStatusAvailable } from '../../selectors/brokerAvailability/selectIsPartnerRewardsRegistrationStatusAvailable';
import { selectUser } from '../../selectors/user';
import { useApplicationContext } from '../../utils/applicationContext';
import { BrokerModalContainer } from '../BrokerModalContainer';
import { useNewbuildingBrokerContext } from '../NewbuildingBrokerWidgetProvider';

export const ActionContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const user = useSelector(selectUser);
  const isRegistrationStatusAvailable = useSelector(selectIsPartnerRewardsRegistrationStatusAvailable);

  const { isBrokerAvailable } = useNewbuildingBrokerContext();

  const {
    hasSeenUnavailableProgramModal,
    isUnavailableProgramModalOpen,
    openUnavailableProgramModal,
    closeUnavailableProgramModal,
  } = useUnavailableProgramModal();

  const isUserAuthorized = !!user?.isAuthenticated;

  const handleDealButtonClick = React.useCallback(() => trackDealButtonClick(isBrokerAvailable), [isBrokerAvailable]);

  const handleClick = React.useCallback(() => {
    openUnavailableProgramModal();
    handleDealButtonClick();
  }, [openUnavailableProgramModal, handleDealButtonClick]);

  const urlForUnAuthorizedUser = config.get<string>('info-broker-frontend.urlForUnAuthorizedUser') ?? '';
  const urlForUserWithStatusAvailable = config.get<string>('info-broker-frontend.urlForUserWithStatusAvailable') ?? '';

  if (!isUserAuthorized) {
    return <ConnectToProgramButton onClick={handleDealButtonClick} href={urlForUnAuthorizedUser} />;
  }

  if (isRegistrationStatusAvailable) {
    return <ConnectToProgramButton onClick={handleDealButtonClick} href={urlForUserWithStatusAvailable} />;
  }

  // Для статусов inProgress, connected.
  if (isBrokerAvailable) {
    return <BrokerModalContainer buttonText="Провести сделку" onDealButtonClick={handleDealButtonClick} />;
  }

  // Для статуса unavailable.
  return (
    <>
      {!hasSeenUnavailableProgramModal && <ConnectToProgramButton onClick={handleClick} />}
      <UnavailableProgramModal isOpen={isUnavailableProgramModalOpen} onClose={closeUnavailableProgramModal} />
    </>
  );
};
